import Mousetrap from 'mousetrap';
import { EditFormHandler } from './edit-form-handler.js';
import UIUtils from './ui-utils.js';

export default class ControlBarHandlers {
    constructor() {
        this.selectedItems = [];
        this.initEventListeners();
        this.bindKeyboardShortcuts();
    }

    initEventListeners() {

        const buttonHandlers = [

            { selector: '.btn-delete-rejected', handler: () => this.handleDeleteRejected() },
            { selector: '.btn-delete-categories', handler: () => this.handleDeleteCategories() },

            { selector: '.btn-rate.reject', handler: () => this.handleRateChange('reject') },
            { selector: '.btn-rate.fair', handler: () => this.handleRateChange('fair') },
            { selector: '.btn-rate.good', handler: () => this.handleRateChange('good') },
            { selector: '.btn-rate.best', handler: () => this.handleRateChange('best') },

            //Add new item
            { selector: '.breadcrumb .btn-add-new', handler: () => this.handleAddNewItem() },


            //Bulk actions
            { selector: '.btn-set-categories.bulk', handler: () => this.handleSetBulkCategories() },
            { selector: '.btn-set-tags.bulk', handler: () => this.handleSetBulkTags() },
            { selector: '.btn-set-pricing.bulk', handler: () => this.handleSetBulkPricing() },

        ];

        buttonHandlers.forEach(({ selector, handler }) => {
            const button = document.querySelector(selector);
            if (button) {
                button.addEventListener('click', handler);
            }
        });
    }

    bindKeyboardShortcuts() {
        Mousetrap.bind('del', () => this.handleDelete());
        Mousetrap.bind('ctrl+m', () => this.handleBrowseFilter());
    }

    updateSelectedItems(selectedItems) {
        this.selectedItems = selectedItems;
    }

    getPostData() {

        //const contributorIdInput = document.getElementById('contributorId');
        //const contributorId = contributorIdInput ? contributorIdInput.value : null;

        //const hostIdInput = document.getElementById('hostId');
        //const hostId = hostIdInput ? hostIdInput.value : null;

        //const apiUrlInput = document.getElementById('apiUrl');
        //const apiUrl = apiUrlInput ? apiUrlInput.value : null;

        const itemIds = this.selectedItems.map(item => item.getAttribute('data-id'));

        return {
            ItemIds: itemIds,
            //ContributorId: contributorId,
            //HostId: hostId,
            //ApiUrl: apiUrl
        };
    }

    handleDeleteRejected() {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        const modal = UIUtils.openModal('/modal/delete-rejected', postData, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/delete-rejected-confirmed';
                new EditFormHandler(formElement, endpoint, "delete-rejected");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Rejected Artworks Deleted Successfully');

                        UIUtils.toast('success', 'Rejected Artworks Deleted.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }
        },
            () => { },
            () => { return true; });
    }

    handleDeleteCategories() {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        const modal = UIUtils.openModal('/modal/delete-categories', postData, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/delete-categories-confirmed';
                new EditFormHandler(formElement, endpoint, "delete-rejected");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Categories Deleted Successfully');

                        UIUtils.toast('success', 'Categories Deleted.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }
        },
            () => { },
            () => { return true; });
    }


    reloadBrowseList() {
        fetch('/list/artworks/browse')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.text();
            })
            .then(html => {
                const itemsList = document.querySelector('.items-list');
                if (itemsList) {
                    itemsList.innerHTML = html;
                }
            })
            .catch(error => {
                console.error('Error loading browse filters:', error);
                UIUtils.toast('error', 'Error reloading browse filters. Please try again.', () => { });
            });
    }

    handleAddNewItem() {
        const currentUrl = new URL(window.location.href);
        const path = currentUrl.pathname;

        if (path === '/categories') {
            this.addNewCategory();
        } else {
            console.error('No handler defined for this path:', path);
        }
    }

    addNewCategory() {
        //we should load the "path" hidden input field that has the current path
        const pathInput = document.getElementById('path');
        const path = pathInput ? pathInput.value : null;

        const modal = UIUtils.openModal(`/modal/add-category?path=${path}`, {}, () => {

            console.log('Opened add new category modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/add-category-apply';
                new EditFormHandler(formElement, endpoint, "add-category");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Created category');

                        window.location.reload();

                        //UIUtils.toast('success', 'Created category.', () => {
                        //    window.location.reload();
                        //});
                    }
                }, { once: true });
            }
        },
            () => { },
            () => { return true; });
    }

    handleBrowseFilter() {

        const modal = UIUtils.openModal('/modal/browse-filters', {}, () => {

            console.log('Opened browse filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/browse-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied browse filters');
                        //this.reloadBrowseList();
                        /*window.location.reload();*/

                        const currentUrl = window.location.origin + window.location.pathname;
                        window.location.href = currentUrl;

                        //Reload browse filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();

                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearFilters(modal));
            }

            // Handle sort direction toggle
            const sortDirectionButton = modal.modal.querySelector('.btn-sort-direction');
            const sortDirectionInput = modal.modal.querySelector('#SortDirection');
            const ascIcon = sortDirectionButton.querySelector('.ti-sort-ascending-2');
            const descIcon = sortDirectionButton.querySelector('.ti-sort-descending-2');

            // Function to update the sort direction and icons
            const updateSortDirection = () => {
                const isAsc = sortDirectionInput.value === 'asc';
                ascIcon.classList.toggle('hidden', !isAsc);
                descIcon.classList.toggle('hidden', isAsc);
            };

            // Initialize the icon state
            updateSortDirection();

            // Add click event to toggle sort direction
            sortDirectionButton.addEventListener('click', () => {
                sortDirectionInput.value = sortDirectionInput.value === 'asc' ? 'desc' : 'asc';
                updateSortDirection();
            });
        },
            () => { },
            () => { return true; });
    }

    handlePagesFilter() {

        const modal = UIUtils.openModal('/modal/page-filters', {}, () => {

            console.log('Opened page filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/page-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied page filters');

                        const currentUrl = window.location.origin + window.location.pathname;
                        window.location.href = currentUrl;

                        //Reload filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearPageFilters(modal));
            }

            // Handle sort direction toggle
            const sortDirectionButton = modal.modal.querySelector('.btn-sort-direction');
            const sortDirectionInput = modal.modal.querySelector('#SortDirection');
            const ascIcon = sortDirectionButton.querySelector('.ti-sort-ascending-2');
            const descIcon = sortDirectionButton.querySelector('.ti-sort-descending-2');

            // Function to update the sort direction and icons
            const updateSortDirection = () => {
                const isAsc = sortDirectionInput.value === 'asc';
                ascIcon.classList.toggle('hidden', !isAsc);
                descIcon.classList.toggle('hidden', isAsc);
            };

            // Initialize the icon state
            updateSortDirection();

            // Add click event to toggle sort direction
            sortDirectionButton.addEventListener('click', () => {
                sortDirectionInput.value = sortDirectionInput.value === 'asc' ? 'desc' : 'asc';
                updateSortDirection();
            });
        },
            () => { },
            () => { return true; });
    }

    handleCategoryFilter() {

        const modal = UIUtils.openModal('/modal/category-filters', {}, () => {

            console.log('Opened category filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/category-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied category filters');

                        window.location.reload();
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearCategoryFilters(modal));
            }

            // Handle sort direction toggle
            const sortDirectionButton = modal.modal.querySelector('.btn-sort-direction');
            const sortDirectionInput = modal.modal.querySelector('#SortDirection');
            const ascIcon = sortDirectionButton.querySelector('.ti-sort-ascending-2');
            const descIcon = sortDirectionButton.querySelector('.ti-sort-descending-2');

            // Function to update the sort direction and icons
            const updateSortDirection = () => {
                const isAsc = sortDirectionInput.value === 'asc';
                ascIcon.classList.toggle('hidden', !isAsc);
                descIcon.classList.toggle('hidden', isAsc);
            };

            // Initialize the icon state
            updateSortDirection();

            // Add click event to toggle sort direction
            sortDirectionButton.addEventListener('click', () => {
                sortDirectionInput.value = sortDirectionInput.value === 'asc' ? 'desc' : 'asc';
                updateSortDirection();
            });
        },
            () => { },
            () => { return true; });
    }

    handleClearFilters(modal) {
        fetch('/browse-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    console.log('Filters cleared successfully');

                    window.location.reload();

                    //this.reloadBrowseList();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }


    handleClearPageFilters(modal) {
        fetch('/page-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    console.log('Filters cleared successfully');

                    window.location.reload();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }

    handleClearCategoryFilters(modal) {
        fetch('/category-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    console.log('Filters cleared successfully');

                    window.location.reload();

                    //this.reloadBrowseList();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }

    handleRateChange(rate) {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        const modal = UIUtils.openModal(`/modal/change-rating/${rate}`, postData, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/change-rating-confirmed';
                new EditFormHandler(formElement, endpoint, rate);

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Ratings updated successfully');

                        UIUtils.toast('success', 'Ratings updated.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }
        },
            () => { },
            () => { return true; });
    }

    handleSetBulkCategories() {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        const modal = UIUtils.openModal(`/modal/bulk-artwork-categories`, postData, () => {
            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');
            if (formElement) {
                const endpoint = '/set-bulk-categories';

                new EditFormHandler(formElement, endpoint, "set-bulk-categories");

                document.addEventListener('formSaved', (e) => {
                    if (e.detail && e.detail.success) {
                        modal.close();
                        console.log('Applied artwork categories successfully');
                        UIUtils.toast('success', 'Categories updated.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Relocated JavaScript
            function filterCategories() {

                const input = modal.modal.querySelector("#categoryFilter");

                if (!input) return;

                const filter = input.value.toUpperCase();
                const cardContainer = modal.modal.querySelector("#categoryContainer");
                const cards = cardContainer.getElementsByTagName("li");

                for (let i = 0; i < cards.length; i++) {
                    const label = cards[i].querySelector("label, span");
                    if (label) {
                        const txtValue = label.textContent || label.innerText;
                        const display = txtValue.toUpperCase().indexOf(filter) > -1 ? "" : "none";
                        cards[i].style.display = display;

                        if (display === "") {
                            let parent = cards[i].closest('ul');
                            while (parent && parent.id !== "categoryContainer") {
                                parent.style.display = "";
                                parent = parent.closest('ul');
                            }
                        }
                    }
                }
            }

            function toggleSubcategories(elementId) {
                const subCategoryList = modal.modal.querySelector(`#${elementId}`);
                if (subCategoryList) {
                    const display = subCategoryList.style.display === "none" ? "block" : "none";
                    subCategoryList.style.display = display;
                }
            }

            function toggleValueTag(element) {
                element.classList.toggle('on');
            }

            // Attach event listeners
            var categoryFilter = modal.modal.querySelector("#categoryFilter");

            if (categoryFilter) {
                modal.modal.querySelector("#categoryFilter").onkeyup = filterCategories;
            }

            modal.modal.querySelectorAll('[data-toggle]').forEach(toggle => {
                toggle.onclick = function () {
                    toggleSubcategories(toggle.getAttribute('data-toggle'));
                };
            });

            modal.modal.querySelectorAll('.value-tag').forEach(tag => {
                tag.onclick = function () {
                    toggleValueTag(tag);
                };
            });

            // Register the clear categories button handler here
            const clearCategoriesButton = modal.modal.querySelector('.btn-clear-categories');
            if (clearCategoriesButton) {
                clearCategoriesButton.addEventListener('click', () => this.handleClearCategories(modal, "set-bulk-categories"));
            }

        }, () => { }, () => { return true; });
    }

    handleClearCategories(modal, artworkId) {
        fetch(`/clear-artwork-categories/${artworkId}`, { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    console.log('Categories cleared successfully');

                    window.location.reload();

                    //this.reloadBrowseList();

                    UIUtils.toast('success', 'Cleared categories.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear categories');
                }
            })
            .catch(error => {
                console.error('Error clearing categories:', error);
            });
    }

    handleSetBulkTags() {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        const modal = UIUtils.openModal(`/modal/bulk-artwork-tags`, postData, () => {
            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');
            if (formElement) {
                const endpoint = '/set-bulk-tags';

                new EditFormHandler(formElement, endpoint, "set-bulk-tags");

                document.addEventListener('formSaved', (e) => {
                    if (e.detail && e.detail.success) {
                        modal.close();
                        console.log('Applied artwork tags successfully');
                        UIUtils.toast('success', 'Tags updated.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }

            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear categories button handler here
            const clearTagsButton = modal.modal.querySelector('.btn-clear-tags');
            if (clearTagsButton) {
                clearTagsButton.addEventListener('click', () => this.handleClearTags(modal, "set-bulk-tags"));
            }

        }, () => { }, () => { return true; });
    }

    handleSetBulkPricing() {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        const modal = UIUtils.openModal(`/modal/bulk-artwork-pricing`, postData, () => {
            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');
            if (formElement) {
                const endpoint = '/set-bulk-pricing';

                new EditFormHandler(formElement, endpoint, "set-bulk-pricing");

                document.addEventListener('formSaved', (e) => {
                    if (e.detail && e.detail.success) {
                        modal.close();
                        console.log('Applied artwork pricing successfully');
                        UIUtils.toast('success', 'Pricing updated.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Register the clear categories button handler here
            const clearTagsButton = modal.modal.querySelector('.btn-clear-tags');
            if (clearTagsButton) {
                clearTagsButton.addEventListener('click', () => this.handleClearBulkPricing(modal, "set-bulk-pricing"));
            }

        }, () => { }, () => { return true; });
    }
}